import Script from 'next/script'

function GobblerMintAnimationScripts() {
  return (
    <>
      {/* <Script
        strategy="beforeInteractive"
        id={'createjs'}
        src="https://cdn.artgobblers.com/web/vendor/createjs.min.js"
      /> */}

      <Script
        strategy="beforeInteractive"
        id={'mint-gobbler-canvas-script'}
        src="/animations/mint-gobbler/mint-gobbler-canvas.js"
      />

      {
        <Script
          id={'mint-gobbler-animation-bootstrap'}
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
            var mintGobblerCanvas, mintGobblerStage, mintGobblerExportRoot, mintGobblerAnimContainer, mintGobblerDomOverlayContainer, mintGobblerFnStartAnimation;

            const initMintGobblerAnimation = () => {
              mintGobblerCanvas = document.getElementById("mint-gobbler-canvas");
              mintGobblerAnimContainer = document.getElementById("mint-gobbler-animation-container");
              mintGobblerDomOverlayContainer = document.getElementById("mint-gobbler-dom-overlay-container");
              var comp=AdobeAn.getComposition("F7487C7B10174DF2B9DD71A73A1ACC6D");
              var lib=comp.getLibrary();
              var loader = new createjs.LoadQueue(false);
              // jj added
              loader.setMaxConnections(6);
              loader.addEventListener("fileload", function(evt){handleFileLoad(evt,comp)});
              loader.addEventListener("complete", function(evt){handleComplete(evt,comp)});
              var lib=comp.getLibrary();
              loader.loadManifest(lib.properties.manifest);
            }
            function handleFileLoad(evt, comp) {
              var images=comp.getImages();	
              if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }	
            }
            function handleComplete(evt,comp) {
              //This function is always called, irrespective of the content. You can use the variable "mintGobblerStage" after it is created in token create_stage.
              var lib=comp.getLibrary();
              var ss=comp.getSpriteSheet();
              var queue = evt.target;
              var ssMetadata = lib.ssMetadata;
              for(i=0; i<ssMetadata.length; i++) {
                ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
              }
              var preloaderDiv = document.getElementById("gobbler-mint-animation-preloader");
              preloaderDiv.style.display = 'none';
              mintGobblerCanvas.style.display = 'block';
              mintGobblerExportRoot = new lib.MintGobblerCanvas();
              mintGobblerStage = new lib.Stage(mintGobblerCanvas);	
              //Registers the "tick" event listener.
              mintGobblerFnStartAnimation = function() {
                mintGobblerStage.addChild(mintGobblerExportRoot);
                createjs.Ticker.framerate = lib.properties.fps;
                createjs.Ticker.addEventListener("tick", mintGobblerStage);
                createjs.Ticker.addEventListener("tick", () => {
                  const curFrameId = mintGobblerStage.getChildAt(0).currentFrame
                  useGobblerMintAnimationCoordinator.setState({ frame: curFrameId, isReady: true })
                });
              }	    
              // Code to support hidpi screens and responsive scaling.
              AdobeAn.makeResponsive(false,'both',false,1,[mintGobblerCanvas,mintGobblerAnimContainer,mintGobblerDomOverlayContainer]);	
              AdobeAn.compositionLoaded(lib.properties.id);
              mintGobblerFnStartAnimation();
  
              mintGobblerStage.getChildAt(0).gotoAndStop(0)
            }
  
            
            window.initMintGobblerAnimation = initMintGobblerAnimation
        `,
          }}
        ></Script>
      }
    </>
  )
}

export default GobblerMintAnimationScripts
